module.exports = __webpack_public_path__ + "static/media/JadavpurUniversity_Logo.2cf71e11.png";